export const formatDateTime = (dateTimeString) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const date = new Date(dateTimeString);
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  let hours = date.getHours();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  const minutes = date.getMinutes();
  return `${month} ${day < 10 ? "0" : ""}${day}, ${year} ${hours}:${
    minutes < 10 ? "0" : ""
  }${minutes} ${ampm}`;
};
